import React, { useMemo, useRef, useEffect, useState } from "react";
import Select from "react-select";
import ModuleLight from "./moduleLight";
import SingleLight from "./singleLight";
import Helpers from "../../../helper/helper";

const LightBarPreviewComponent = ({
  lightData,
  closeLightbarPreviewModel,
  tooltipData,
  currentZoneData,
  setLightbarLightheadsCallingBlocking,
}) => {
  let lightbar = tooltipData.replace(/<br \/>/gi, "<br>");
  lightbar = lightbar.replace(/<br\/>/gi, "<br>");
  lightbar = lightbar.split("<br>");
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  // calculate bounds
  const { maxX, maxY } = useMemo(
    () => ({
      maxX: Math.max(...lightData.map((l) => +l.left + +l.width)),
      maxY: Math.max(...lightData.map((l) => +l.top + +l.height)),
    }),
    [lightData]
  );

  const sortedLightData = lightData
    .sort((a, b) => +a.lightheadPosition - +b.lightheadPosition)
    .filter((light) => light.angle !== "90" && light.angle !== "270");
  const topLightheads = sortedLightData.filter((lighthead) => lighthead.top === "0");

  // calculate scale to fit container
  useEffect(() => {
    const resize = () => {
      if (!containerRef.current) return;

      const { offsetWidth, offsetHeight } = containerRef.current;
      const scaleX = offsetWidth / maxX;
      const scaleY = offsetHeight / maxY;

      // maintain aspect ratio
      const newScale = Math.min(scaleX, scaleY) * 0.65;
      if (lightData.length <= 8 && newScale > 15) {
        setScale(15);
        return;
      }
      setScale(newScale);
    };

    resize();
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [maxX, maxY]);

  const moduleOutputs =
    lightData.filter((light) => light.moduleOutputs && Array.isArray(light.moduleOutputs)).length > 0;

  const FindSelectedIndex = (options, value) => options.findIndex((x) => x.value === value);
  const colorMap = [...(currentZoneData?.lightheads || [])]
    .sort((a, b) => {
      if (a.lightheadPosition == null) return 0;
      if (b.lightheadPosition == null) return 0;

      return a.lightheadPosition - b.lightheadPosition;
    })
    .reduce(
      (acc, lighthead, i) => ({
        ...acc,
        [i]: Object.keys(lighthead.color).map((key) => ({
          ...lighthead,
          ...lighthead.color[key],
        })),
      }),
      {}
    );

  const solo = currentZoneData?.lightheads.length === 0;
  return (
    <>
      <div id="previewLightbar-modal" className="m-auto">
        <div className="modal-dialog m-0">
          <div className="modal-content">
            <div className="d-flex align-items-center">
              <h2 className="modal-title text-white text-uppercase mt-0">PREVIEW</h2>
              <div className="close-icon text-end ms-auto">
                <button type="button" className="close" data-dismiss="modal" onClick={closeLightbarPreviewModel}>
                  <span aria-hidden="true">
                    <i className="fa fa-times text-red" />
                  </span>
                </button>
              </div>
            </div>
            <div className="lightbar-description">
              {lightbar.map((data, i) => (
                <div className="text-white mt-10">
                  {data}
                  {i === 0 && (
                    <span className="zone-text">
                      , ZONE-
                      {currentZoneData.zone}
                    </span>
                  )}
                </div>
              ))}
            </div>
            <div
              className="canvas-position mb-5"
              ref={containerRef}
              style={{
                padding: "1.5rem 0 2rem 0", // spacing inside
              }}
            >
              {/* Scaled Canvas, In case of Freedom V data needs recalculation */}
              <div
                style={{
                  position: "relative",
                  width: maxX * scale - (moduleOutputs ? 40 : 0),
                  minHeight: "90px",
                  margin: "0 auto",
                  display: "flex",
                }}
              >
                {lightData.map((light, lightIndex) =>
                  light.moduleOutputs ? (
                    <ModuleLight
                      key={light.outputId}
                      light={light}
                      lightData={lightData}
                      topLightheads={topLightheads}
                      scale={scale}
                      lightIndex={lightIndex}
                    />
                  ) : (
                    <SingleLight key={light.outputId} light={light} scale={scale} lightIndex={lightIndex} />
                  )
                )}
              </div>
            </div>
            {!solo ? (
              <div className="table-responsive" style={{ height: "calc(100vh - 450px)" }}>
                <table className="table el-header table-bordered align-middle table-dark">
                  <thead>
                    <tr>
                      {currentZoneData && currentZoneData?.bxrVersion === "2.0" ? <th>Lighthead Position</th> : null}
                      <th>Source</th>
                      <th>Position</th>
                      <th>Calling Intensity</th>
                      <th>Blocking Intensity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(colorMap).map((colorRow, mainIndex) =>
                      colorMap[colorRow].map((row, colorIndex) => (
                        <tr key={`${colorRow}-${row.id + colorIndex}`}>
                          {currentZoneData && currentZoneData?.bxrVersion === "2.0" ? (
                            <td>{colorIndex <= 0 && row?.lightheadPosition ? row.lightheadPosition : null}</td>
                          ) : null}
                          <td>{`${row?.modelNumber} - ${row?.color}`}</td>
                          <td>{row.position}</td>

                          <td style={{ minWidth: "180px" }}>
                            <div className="form-group cursor-pt mb-0">
                              <Select
                                value={
                                  currentZoneData?.intensityOptions[
                                    FindSelectedIndex(currentZoneData?.intensityOptions, row.call_intensity)
                                  ]
                                }
                                options={currentZoneData?.intensityOptions}
                                className="select-sdd"
                                isSearchable={false}
                                // menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={Helpers.getDropDownOptionsForPreviewModel()}
                                onChange={(e) => {
                                  setLightbarLightheadsCallingBlocking(
                                    e,
                                    mainIndex,
                                    colorIndex,
                                    row.id,
                                    "call_intensity",
                                    currentZoneData
                                  );
                                }}
                              />
                            </div>
                          </td>
                          <td style={{ minWidth: "180px" }}>
                            <div className="form-group cursor-pt mb-0">
                              <Select
                                value={
                                  currentZoneData?.intensityOptions[
                                    FindSelectedIndex(currentZoneData?.intensityOptions, row.block_intensity)
                                  ]
                                }
                                options={currentZoneData?.intensityOptions}
                                className="select-sdd"
                                isSearchable={false}
                                // menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={Helpers.getDropDownOptionsForPreviewModel()}
                                onChange={(e) => {
                                  setLightbarLightheadsCallingBlocking(
                                    e,
                                    mainIndex,
                                    colorIndex,
                                    row.id,
                                    "block_intensity",
                                    currentZoneData
                                  );
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default LightBarPreviewComponent;
